// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"66e95cd5","3434":"66e95cd5","3799":"66e95cd5","3932":"66e95cd5","4364":"e18a9a6a","5910":"66e95cd5","9835":"66e95cd5"}[chunkId] + ".chunk.css";
};